// Two bounded identifiers per entry leave room for the complete BPP envelope.
const MAX_DIRECTORY_ENTRIES = 64;
const routeFields = ['agent_id', 'channel_id', 'connection_generation'];
const object = (value) => !!value && typeof value === 'object' && !Array.isArray(value);
const id = (value) => typeof value === 'string' && /^[A-Za-z0-9_:.@/-]{1,512}$/.test(value);
export function parseSessionDirectoryRequest(value) {
    if (!object(value) || Object.keys(value).length !== 4 || value.action !== 'list_sessions' || !routeFields.every(field => id(value[field])))
        throw new Error('invalid_session_directory_request');
    return value;
}
export function parseSessionDirectoryResult(value, expected) {
    if (!object(value) || Object.keys(value).length !== 6 || value.scope !== 'registered' || typeof value.complete !== 'boolean'
        || !routeFields.every(field => id(value[field]) && (!expected || value[field] === expected[field]))
        || !Array.isArray(value.sessions) || value.sessions.length > MAX_DIRECTORY_ENTRIES)
        throw new Error('invalid_session_directory');
    const bindings = new Set();
    let defaults = 0;
    for (const entry of value.sessions) {
        if (!object(entry) || Object.keys(entry).length !== 3 || !id(entry.binding_id) || !id(entry.native_session_id) || typeof entry.is_default !== 'boolean'
            || bindings.has(entry.binding_id) || entry.is_default && ++defaults > 1)
            throw new Error('invalid_session_directory');
        bindings.add(entry.binding_id);
    }
    return value;
}
export function createSessionDirectory(request, entries) {
    parseSessionDirectoryRequest(request);
    const sessions = [...entries].sort((a, b) => Number(b.is_default) - Number(a.is_default) || (a.binding_id < b.binding_id ? -1 : a.binding_id > b.binding_id ? 1 : 0));
    return parseSessionDirectoryResult({ agent_id: request.agent_id, channel_id: request.channel_id, connection_generation: request.connection_generation,
        scope: 'registered', sessions: sessions.slice(0, MAX_DIRECTORY_ENTRIES), complete: sessions.length <= MAX_DIRECTORY_ENTRIES });
}
//# sourceMappingURL=session-directory.js.map